angular.module('CarsSaraBo').controller('HolidayController', ['$scope', '$routeParams', 'HolidayService', '$q', '$http', '$location', '$timeout', '$translate', '$filter',
    function ($scope, $routeParams, holidayService, $q, $http, $location, $timeout, $translate, $filter) {

        $scope.initialize = function () {
            $scope.loadCompany();
            $scope.holiday = {}
            $scope.date = new Date();
            $scope.errorField = {};
            $scope.errorMessage = 'holiday.ERROR_REQUIRED';
            $scope.today = new Date();
            $scope.config = {
                itemsPerPage: 10,
                currentPage: 1,
                numPages: 0,
                totalItems: 0
            }
            $scope.pageHolidayList = [];
            $scope.datepickerOptions = {
                language: 'es'
            }
            $scope.editableHoliday = $scope.loggedUserAllowed('PERM_HOLIDAY_EDIT') || $scope.loggedUserAllowed('PERM_HOLIDAY_DELETE');
            $scope.order = {field: "", desc: false};
            $scope.todayDate = "";
            $scope.updateDate = calculateMaxDate();
        }

        function calculateMaxDate() {
            var date = new Date();
            let dateWithYears = new Date(date.setFullYear(new Date().getFullYear() + 2));
            return formatDate(dateWithYears);
        }

        function formatDate(inputFormat) {
            function pad(s) {
                return (s < 10) ? '0' + s : s;
            }

            var d = new Date(inputFormat);
            return [d.getFullYear(), pad(d.getMonth() + 1), pad(d.getDate())].join('-');
        }

        $scope.sort = function (fieldName, desc) {

            if ($scope.order.field != fieldName) {
                $scope.order.field = fieldName;
                $scope.order.desc = desc != undefined ? desc : false;
            } else {
                $scope.order.desc = desc != undefined ? desc : !$scope.order.desc;
            }

            $scope.holidayList = $filter('orderBy')($scope.holidayList, $scope.order.field, $scope.order.desc);

            $scope.goToFirstPage();
        }

        $scope.goToFirstPage = function () {
            $scope.currentPage = 1;
            $scope.changePage();
        }

        $scope.loadCompany = function () {
            holidayService.query({companyOid: $routeParams.companyOid}, function (response) {
                $scope.holidayList = response;
                $scope.config.totalItems = $scope.holidayList.length;
                $scope.config.numPages = Math.floor($scope.holidayList.length / $scope.config.itemsPerPage);
                $scope.changePage();
            });
        }

        $scope.changePage = function () {
            var startItem = $scope.config.itemsPerPage * $scope.config.currentPage;
            $scope.pageHolidayList = $scope.holidayList.slice(startItem - $scope.config.itemsPerPage, startItem);
        }

        $scope.itemsToRemove = function () {
            return _.filter($scope.holidayList, {"selected": true});
        }

        $scope.formatDate = function (date) {
            return date.substring(8, 10) + "/" + date.substring(5, 7) + "/" + date.substring(0, 4);
        }

        $scope.remove = function () {
            var toRemove = $scope.itemsToRemove();

            if (toRemove.length == 0) return;

            $scope.showModal("REMOVE_ALERT_TITLE", "REMOVE_ALERT_DESCRIPTION", function () {
                toRemove.forEach(function (holiday) {
                    $q.all([
                        holidayService.delete({companyOid: $routeParams.companyOid, oid: holiday.oid}).$promise,
                    ]).then(function () {
                        $scope.initialize();
                        $scope.submitted = false;
                        $scope.notifyInfoByCode('common.confirmationMessage.SUCCESS_DELETE');
                    });
                })
            });
        }

        $scope.getNoSingleValueDate = function (dateFunction) {
            return (dateFunction > 9) ? dateFunction.toString() : '0' + dateFunction.toString();
        }

        $scope.formatToyyyyMMdd = function (date) {
            return date.getFullYear().toString() + $scope.getNoSingleValueDate(date.getMonth() + 1) + $scope.getNoSingleValueDate(date.getDate());
        }

        $scope.formatToyyyyMMddMiddleScore = function (date) {
            return date.getFullYear().toString() + "-" + $scope.getNoSingleValueDate(date.getMonth() + 1) + "-" + $scope.getNoSingleValueDate(date.getDate());
        }

        $scope.formatToyyyyMMddSlash = function (date) {
            return $scope.getNoSingleValueDate(date.getDate()) + "/" + $scope.getNoSingleValueDate(date.getMonth() + 1) + "/" + date.getFullYear().toString();
        }

        $scope.updateValidation = function (field) {
            if ($scope.errorField != undefined && $scope.errorField[field]) {
                $scope.errorField[field] = null;
            }
        }

        function validateDate() {

            var today = new Date();
            today.setHours(0, 0, 0, 0);

            var inputValue = document.getElementById('dateInput').value;

            if (inputValue === '') {
                $scope.errorField['date'] = "input-error";
                $scope.errorMessage = 'holiday.ERROR_REQUIRED';
                return false;
            }

            if (!/^\d{1,2}\/\d{1,2}\/\d{4}$/.test(inputValue)) {
                $scope.errorField['date'] = "input-error";
                $scope.errorMessage = 'holiday.ERROR_INVALID_DATE';
                return false;
            }

            var hasSameDate = _.some($scope.holidayList, function (holiday) {
                return (holiday.date == $scope.formatToyyyyMMddMiddleScore($scope.date));
            })


            if (hasSameDate) {
                $scope.errorField['date'] = "input-error";
                $scope.errorMessage = 'holiday.ERROR_EXISTING_DATE';
                return false;
            }

            if ($scope.date < today) {
                $scope.errorField['date'] = "input-error";
                $scope.errorMessage = 'holiday.ERROR_PAST_DATE';
                $scope.todayDate = $scope.formatToyyyyMMddSlash(today);
                return false;
            }

            return true;
        }

        $scope.valid = function () {
            var isValid = true;

            if ($scope.holiday.description === undefined) {
                $scope.errorField['holidayDescription'] = "input-error";
                isValid = false;
            }

            isValid = validateDate();
            return isValid;
        }

        $scope.save = function () {
            $scope.errorField = {};
            if ($scope.valid() && $scope.holidayForm.$valid) {
                $scope.holiday.date = $scope.formatToyyyyMMdd($scope.date);
                $q.all([
                    holidayService.save({companyOid: $routeParams.companyOid}, $scope.holiday).$promise,
                ]).then(function (response) {
                    $scope.initialize();
                    $scope.submitted = false;
                    $scope.notifyInfoByCode('holiday.confirmationMessage.SUCCESS_SAVE');
                });
            }
        }
        $scope.initialize();
    }]);


//////////////////
// WEBPACK FOOTER
// ./public/app/controllers/holiday_controller.js
// module id = 901
// module chunks = 3